import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.fields': {
         nationalIdentificationNumberCountry: {
            label: 'Kraj nadania',
         },
         passportCountry: {
            label: 'Kraj wydania paszportu',
         },
         passportValidTo: {
            label: 'Data ważności',
            validate: {
               cannotBeDateInPast: 'Nie może być datą w przeszłości.',
            },
         },
         patientExternalIdentifierType: {
            label: 'Typ identyfikatora',
            selectItemName: {
               NationalIdentificationNumber: 'Osobisty numer identyfikacyjny (R)',
               Passport: 'Paszport',
               Pesel: 'PESEL',
            },
         },
         patientExternalIdentifierValue: {
            label: 'Identyfikator',
            placeholder: {
               NationalIdentificationNumber: 'PIN UE',
               Passport: 'seria i numer paszportu',
               Pesel: '',
            },
            validate: {
               invalidNationalIdentificationNumber: 'Niepoprawny numer PIN UE',
               invalidNationalIdentificationNumberPattern: 'Nie może zawierać znaków: ^ | ~ \\ &',
               invalidPassport: 'Niepoprawny paszport',
               invalidPassportPattern: 'Nie może zawierać białych znaków',
               invalidPesel: 'Niepoprawny numer PESEL',
            },
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.fields');
